// Character map of all characters at font-size 13
// export default {
//     "0": 7.4,
//     "1": 7.4,
//     "2": 7.4,
//     "3": 7.4,
//     "4": 7.4,
//     "5": 7.4,
//     "6": 7.4,
//     "7": 7.4,
//     "8": 7.4,
//     "9": 7.4,
//     " ": 3.1,
//     "!": 3.6,
//     "\"": 5.5,
//     "#": 8.7,
//     "$": 7.4,
//     "%": 11.2,
//     "&": 8.7,
//     "'": 3.2,
//     "(": 4.3,
//     ")": 4.3,
//     "*": 6.3,
//     "+": 7.4,
//     ",": 3.2,
//     "-": 3.9,
//     ".": 3.2,
//     "/": 5,
//     ":": 3.2,
//     ";": 3.2,
//     "<": 7.4,
//     "=": 7.4,
//     ">": 7.4,
//     "?": 5.3,
//     "@": 12.4,
//     "A": 8.7,
//     "B": 8.4,
//     "C": 8.1,
//     "D": 9.3,
//     "E": 7.5,
//     "F": 7,
//     "G": 8.8,
//     "H": 9.2,
//     "I": 3.5,
//     "J": 6.5,
//     "K": 8.2,
//     "L": 6.8,
//     "M": 11.4,
//     "N": 9.5,
//     "O": 10.2,
//     "P": 8,
//     "Q": 10.2,
//     "R": 8.2,
//     "S": 7,
//     "T": 7.4,
//     "U": 9,
//     "V": 8.6,
//     "W": 12.1,
//     "X": 8.3,
//     "Y": 7.8,
//     "Z": 7.5,
//     "[": 4.3,
//     "\\": 5,
//     "]": 4.3,
//     "^": 7.4,
//     "_": 6.4,
//     "`": 4.9,
//     "a": 6.8,
//     "b": 7.7,
//     "c": 6.1,
//     "d": 7.7,
//     "e": 7.3,
//     "f": 5.1,
//     "g": 7.6,
//     "h": 7.5,
//     "i": 3.3,
//     "j": 3.3,
//     "k": 6.8,
//     "l": 3.6,
//     "m": 11.2,
//     "n": 7.5,
//     "o": 7.7,
//     "p": 7.7,
//     "q": 7.7,
//     "r": 5.1,
//     "s": 5.8,
//     "t": 5.3,
//     "u": 7.5,
//     "v": 6.6,
//     "w": 10.2,
//     "x": 6.7,
//     "y": 6.5,
//     "z": 6.2,
//     "{": 4.4,
//     "|": 3.7,
//     "}": 4.4,
//     "~": 7.4
//   };

export default {
  "0": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  "1": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  "2": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  "3": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  "4": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  "5": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  "6": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  "7": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  "8": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  "9": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  " ": {
    "6": 1.4307692307692308,
    "7": 1.669230769230769,
    "8": 1.9076923076923078,
    "9": 2.1461538461538465,
    "10": 2.3846153846153846,
    "11": 2.623076923076923,
    "12": 2.8615384615384616,
    "13": 3.1000000000000005,
    "14": 3.338461538461538,
    "15": 3.576923076923077,
    "16": 3.8153846153846156,
    "17": 4.053846153846154,
    "18": 4.292307692307693,
    "19": 4.530769230769231,
    "20": 4.769230769230769,
    "21": 5.0076923076923086,
    "22": 5.246153846153846,
    "23": 5.484615384615385,
    "24": 5.723076923076923,
    "25": 5.961538461538462,
    "26": 6.200000000000001
  },
  "!": {
    "6": 1.6615384615384616,
    "7": 1.9384615384615385,
    "8": 2.2153846153846155,
    "9": 2.4923076923076923,
    "10": 2.769230769230769,
    "11": 3.0461538461538464,
    "12": 3.3230769230769233,
    "13": 3.6000000000000005,
    "14": 3.876923076923077,
    "15": 4.153846153846154,
    "16": 4.430769230769231,
    "17": 4.707692307692308,
    "18": 4.984615384615385,
    "19": 5.261538461538462,
    "20": 5.538461538461538,
    "21": 5.815384615384616,
    "22": 6.092307692307693,
    "23": 6.369230769230769,
    "24": 6.6461538461538465,
    "25": 6.923076923076923,
    "26": 7.200000000000001
  },
  '"': {
    "6": 2.5384615384615383,
    "7": 2.9615384615384617,
    "8": 3.3846153846153846,
    "9": 3.8076923076923075,
    "10": 4.230769230769231,
    "11": 4.653846153846154,
    "12": 5.076923076923077,
    "13": 5.5,
    "14": 5.923076923076923,
    "15": 6.346153846153846,
    "16": 6.769230769230769,
    "17": 7.1923076923076925,
    "18": 7.615384615384615,
    "19": 8.038461538461538,
    "20": 8.461538461538462,
    "21": 8.884615384615385,
    "22": 9.307692307692308,
    "23": 9.73076923076923,
    "24": 10.153846153846153,
    "25": 10.576923076923077,
    "26": 11
  },
  "#": {
    "6": 4.015384615384615,
    "7": 4.684615384615384,
    "8": 5.3538461538461535,
    "9": 6.023076923076923,
    "10": 6.6923076923076925,
    "11": 7.36153846153846,
    "12": 8.03076923076923,
    "13": 8.7,
    "14": 9.369230769230768,
    "15": 10.038461538461538,
    "16": 10.707692307692307,
    "17": 11.376923076923076,
    "18": 12.046153846153846,
    "19": 12.715384615384615,
    "20": 13.384615384615385,
    "21": 14.053846153846154,
    "22": 14.72307692307692,
    "23": 15.392307692307693,
    "24": 16.06153846153846,
    "25": 16.73076923076923,
    "26": 17.4
  },
  $: {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  "%": {
    "6": 5.169230769230769,
    "7": 6.03076923076923,
    "8": 6.892307692307692,
    "9": 7.753846153846154,
    "10": 8.615384615384615,
    "11": 9.476923076923075,
    "12": 10.338461538461537,
    "13": 11.2,
    "14": 12.06153846153846,
    "15": 12.923076923076923,
    "16": 13.784615384615384,
    "17": 14.646153846153844,
    "18": 15.507692307692308,
    "19": 16.369230769230768,
    "20": 17.23076923076923,
    "21": 18.092307692307692,
    "22": 18.95384615384615,
    "23": 19.815384615384612,
    "24": 20.676923076923075,
    "25": 21.53846153846154,
    "26": 22.4
  },
  "&": {
    "6": 4.015384615384615,
    "7": 4.684615384615384,
    "8": 5.3538461538461535,
    "9": 6.023076923076923,
    "10": 6.6923076923076925,
    "11": 7.36153846153846,
    "12": 8.03076923076923,
    "13": 8.7,
    "14": 9.369230769230768,
    "15": 10.038461538461538,
    "16": 10.707692307692307,
    "17": 11.376923076923076,
    "18": 12.046153846153846,
    "19": 12.715384615384615,
    "20": 13.384615384615385,
    "21": 14.053846153846154,
    "22": 14.72307692307692,
    "23": 15.392307692307693,
    "24": 16.06153846153846,
    "25": 16.73076923076923,
    "26": 17.4
  },
  "'": {
    "6": 1.4769230769230772,
    "7": 1.7230769230769232,
    "8": 1.9692307692307693,
    "9": 2.2153846153846155,
    "10": 2.4615384615384617,
    "11": 2.707692307692308,
    "12": 2.9538461538461545,
    "13": 3.2,
    "14": 3.4461538461538463,
    "15": 3.6923076923076925,
    "16": 3.9384615384615387,
    "17": 4.184615384615385,
    "18": 4.430769230769231,
    "19": 4.676923076923077,
    "20": 4.923076923076923,
    "21": 5.1692307692307695,
    "22": 5.415384615384616,
    "23": 5.661538461538462,
    "24": 5.907692307692309,
    "25": 6.153846153846154,
    "26": 6.4
  },
  "(": {
    "6": 1.9846153846153844,
    "7": 2.315384615384615,
    "8": 2.646153846153846,
    "9": 2.9769230769230766,
    "10": 3.3076923076923075,
    "11": 3.6384615384615384,
    "12": 3.969230769230769,
    "13": 4.3,
    "14": 4.63076923076923,
    "15": 4.961538461538462,
    "16": 5.292307692307692,
    "17": 5.623076923076923,
    "18": 5.953846153846153,
    "19": 6.2846153846153845,
    "20": 6.615384615384615,
    "21": 6.946153846153846,
    "22": 7.276923076923077,
    "23": 7.607692307692307,
    "24": 7.938461538461538,
    "25": 8.26923076923077,
    "26": 8.6
  },
  ")": {
    "6": 1.9846153846153844,
    "7": 2.315384615384615,
    "8": 2.646153846153846,
    "9": 2.9769230769230766,
    "10": 3.3076923076923075,
    "11": 3.6384615384615384,
    "12": 3.969230769230769,
    "13": 4.3,
    "14": 4.63076923076923,
    "15": 4.961538461538462,
    "16": 5.292307692307692,
    "17": 5.623076923076923,
    "18": 5.953846153846153,
    "19": 6.2846153846153845,
    "20": 6.615384615384615,
    "21": 6.946153846153846,
    "22": 7.276923076923077,
    "23": 7.607692307692307,
    "24": 7.938461538461538,
    "25": 8.26923076923077,
    "26": 8.6
  },
  "*": {
    "6": 2.9076923076923076,
    "7": 3.3923076923076922,
    "8": 3.876923076923077,
    "9": 4.361538461538461,
    "10": 4.846153846153846,
    "11": 5.3307692307692305,
    "12": 5.815384615384615,
    "13": 6.299999999999999,
    "14": 6.7846153846153845,
    "15": 7.269230769230769,
    "16": 7.753846153846154,
    "17": 8.238461538461538,
    "18": 8.723076923076922,
    "19": 9.207692307692309,
    "20": 9.692307692307692,
    "21": 10.176923076923076,
    "22": 10.661538461538461,
    "23": 11.146153846153847,
    "24": 11.63076923076923,
    "25": 12.115384615384615,
    "26": 12.599999999999998
  },
  "+": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  ",": {
    "6": 1.4769230769230772,
    "7": 1.7230769230769232,
    "8": 1.9692307692307693,
    "9": 2.2153846153846155,
    "10": 2.4615384615384617,
    "11": 2.707692307692308,
    "12": 2.9538461538461545,
    "13": 3.2,
    "14": 3.4461538461538463,
    "15": 3.6923076923076925,
    "16": 3.9384615384615387,
    "17": 4.184615384615385,
    "18": 4.430769230769231,
    "19": 4.676923076923077,
    "20": 4.923076923076923,
    "21": 5.1692307692307695,
    "22": 5.415384615384616,
    "23": 5.661538461538462,
    "24": 5.907692307692309,
    "25": 6.153846153846154,
    "26": 6.4
  },
  "-": {
    "6": 1.7999999999999998,
    "7": 2.1,
    "8": 2.4,
    "9": 2.7,
    "10": 3,
    "11": 3.3,
    "12": 3.5999999999999996,
    "13": 3.8999999999999995,
    "14": 4.2,
    "15": 4.5,
    "16": 4.8,
    "17": 5.1,
    "18": 5.4,
    "19": 5.699999999999999,
    "20": 6,
    "21": 6.299999999999999,
    "22": 6.6,
    "23": 6.9,
    "24": 7.199999999999999,
    "25": 7.5,
    "26": 7.799999999999999
  },
  ".": {
    "6": 1.4769230769230772,
    "7": 1.7230769230769232,
    "8": 1.9692307692307693,
    "9": 2.2153846153846155,
    "10": 2.4615384615384617,
    "11": 2.707692307692308,
    "12": 2.9538461538461545,
    "13": 3.2,
    "14": 3.4461538461538463,
    "15": 3.6923076923076925,
    "16": 3.9384615384615387,
    "17": 4.184615384615385,
    "18": 4.430769230769231,
    "19": 4.676923076923077,
    "20": 4.923076923076923,
    "21": 5.1692307692307695,
    "22": 5.415384615384616,
    "23": 5.661538461538462,
    "24": 5.907692307692309,
    "25": 6.153846153846154,
    "26": 6.4
  },
  "/": {
    "6": 2.3076923076923075,
    "7": 2.6923076923076925,
    "8": 3.076923076923077,
    "9": 3.4615384615384617,
    "10": 3.8461538461538463,
    "11": 4.230769230769231,
    "12": 4.615384615384615,
    "13": 5,
    "14": 5.384615384615385,
    "15": 5.769230769230769,
    "16": 6.153846153846154,
    "17": 6.538461538461538,
    "18": 6.923076923076923,
    "19": 7.3076923076923075,
    "20": 7.6923076923076925,
    "21": 8.076923076923077,
    "22": 8.461538461538462,
    "23": 8.846153846153847,
    "24": 9.23076923076923,
    "25": 9.615384615384615,
    "26": 10
  },
  ":": {
    "6": 1.4769230769230772,
    "7": 1.7230769230769232,
    "8": 1.9692307692307693,
    "9": 2.2153846153846155,
    "10": 2.4615384615384617,
    "11": 2.707692307692308,
    "12": 2.9538461538461545,
    "13": 3.2,
    "14": 3.4461538461538463,
    "15": 3.6923076923076925,
    "16": 3.9384615384615387,
    "17": 4.184615384615385,
    "18": 4.430769230769231,
    "19": 4.676923076923077,
    "20": 4.923076923076923,
    "21": 5.1692307692307695,
    "22": 5.415384615384616,
    "23": 5.661538461538462,
    "24": 5.907692307692309,
    "25": 6.153846153846154,
    "26": 6.4
  },
  ";": {
    "6": 1.4769230769230772,
    "7": 1.7230769230769232,
    "8": 1.9692307692307693,
    "9": 2.2153846153846155,
    "10": 2.4615384615384617,
    "11": 2.707692307692308,
    "12": 2.9538461538461545,
    "13": 3.2,
    "14": 3.4461538461538463,
    "15": 3.6923076923076925,
    "16": 3.9384615384615387,
    "17": 4.184615384615385,
    "18": 4.430769230769231,
    "19": 4.676923076923077,
    "20": 4.923076923076923,
    "21": 5.1692307692307695,
    "22": 5.415384615384616,
    "23": 5.661538461538462,
    "24": 5.907692307692309,
    "25": 6.153846153846154,
    "26": 6.4
  },
  "<": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  "=": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  ">": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  "?": {
    "6": 2.446153846153846,
    "7": 2.853846153846154,
    "8": 3.2615384615384615,
    "9": 3.669230769230769,
    "10": 4.076923076923077,
    "11": 4.484615384615385,
    "12": 4.892307692307692,
    "13": 5.299999999999999,
    "14": 5.707692307692308,
    "15": 6.115384615384615,
    "16": 6.523076923076923,
    "17": 6.93076923076923,
    "18": 7.338461538461538,
    "19": 7.746153846153846,
    "20": 8.153846153846153,
    "21": 8.561538461538461,
    "22": 8.96923076923077,
    "23": 9.376923076923076,
    "24": 9.784615384615384,
    "25": 10.192307692307692,
    "26": 10.599999999999998
  },
  "@": {
    "6": 5.723076923076923,
    "7": 6.676923076923076,
    "8": 7.630769230769231,
    "9": 8.584615384615386,
    "10": 9.538461538461538,
    "11": 10.492307692307692,
    "12": 11.446153846153846,
    "13": 12.400000000000002,
    "14": 13.353846153846153,
    "15": 14.307692307692308,
    "16": 15.261538461538462,
    "17": 16.215384615384615,
    "18": 17.169230769230772,
    "19": 18.123076923076923,
    "20": 19.076923076923077,
    "21": 20.030769230769234,
    "22": 20.984615384615385,
    "23": 21.93846153846154,
    "24": 22.892307692307693,
    "25": 23.846153846153847,
    "26": 24.800000000000004
  },
  A: {
    "6": 4.015384615384615,
    "7": 4.684615384615384,
    "8": 5.3538461538461535,
    "9": 6.023076923076923,
    "10": 6.6923076923076925,
    "11": 7.36153846153846,
    "12": 8.03076923076923,
    "13": 8.7,
    "14": 9.369230769230768,
    "15": 10.038461538461538,
    "16": 10.707692307692307,
    "17": 11.376923076923076,
    "18": 12.046153846153846,
    "19": 12.715384615384615,
    "20": 13.384615384615385,
    "21": 14.053846153846154,
    "22": 14.72307692307692,
    "23": 15.392307692307693,
    "24": 16.06153846153846,
    "25": 16.73076923076923,
    "26": 17.4
  },
  B: {
    "6": 3.8769230769230774,
    "7": 4.523076923076923,
    "8": 5.1692307692307695,
    "9": 5.815384615384616,
    "10": 6.461538461538462,
    "11": 7.107692307692308,
    "12": 7.753846153846155,
    "13": 8.4,
    "14": 9.046153846153846,
    "15": 9.692307692307692,
    "16": 10.338461538461539,
    "17": 10.984615384615385,
    "18": 11.630769230769232,
    "19": 12.276923076923076,
    "20": 12.923076923076923,
    "21": 13.569230769230769,
    "22": 14.215384615384616,
    "23": 14.861538461538462,
    "24": 15.50769230769231,
    "25": 16.153846153846153,
    "26": 16.8
  },
  C: {
    "6": 3.738461538461538,
    "7": 4.361538461538461,
    "8": 4.984615384615385,
    "9": 5.607692307692307,
    "10": 6.230769230769231,
    "11": 6.8538461538461535,
    "12": 7.476923076923076,
    "13": 8.1,
    "14": 8.723076923076922,
    "15": 9.346153846153847,
    "16": 9.96923076923077,
    "17": 10.592307692307692,
    "18": 11.215384615384615,
    "19": 11.838461538461539,
    "20": 12.461538461538462,
    "21": 13.084615384615384,
    "22": 13.707692307692307,
    "23": 14.33076923076923,
    "24": 14.953846153846152,
    "25": 15.576923076923077,
    "26": 16.2
  },
  D: {
    "6": 4.292307692307693,
    "7": 5.0076923076923086,
    "8": 5.723076923076923,
    "9": 6.438461538461539,
    "10": 7.153846153846154,
    "11": 7.86923076923077,
    "12": 8.584615384615386,
    "13": 9.3,
    "14": 10.015384615384617,
    "15": 10.73076923076923,
    "16": 11.446153846153846,
    "17": 12.161538461538463,
    "18": 12.876923076923077,
    "19": 13.592307692307694,
    "20": 14.307692307692308,
    "21": 15.023076923076925,
    "22": 15.73846153846154,
    "23": 16.453846153846154,
    "24": 17.169230769230772,
    "25": 17.884615384615387,
    "26": 18.6
  },
  E: {
    "6": 3.4615384615384617,
    "7": 4.038461538461538,
    "8": 4.615384615384615,
    "9": 5.1923076923076925,
    "10": 5.769230769230769,
    "11": 6.346153846153846,
    "12": 6.923076923076923,
    "13": 7.5,
    "14": 8.076923076923077,
    "15": 8.653846153846153,
    "16": 9.23076923076923,
    "17": 9.807692307692308,
    "18": 10.384615384615385,
    "19": 10.961538461538462,
    "20": 11.538461538461538,
    "21": 12.115384615384615,
    "22": 12.692307692307692,
    "23": 13.26923076923077,
    "24": 13.846153846153847,
    "25": 14.423076923076923,
    "26": 15
  },
  F: {
    "6": 3.230769230769231,
    "7": 3.769230769230769,
    "8": 4.3076923076923075,
    "9": 4.846153846153846,
    "10": 5.384615384615385,
    "11": 5.923076923076923,
    "12": 6.461538461538462,
    "13": 7,
    "14": 7.538461538461538,
    "15": 8.076923076923077,
    "16": 8.615384615384615,
    "17": 9.153846153846153,
    "18": 9.692307692307692,
    "19": 10.23076923076923,
    "20": 10.76923076923077,
    "21": 11.307692307692308,
    "22": 11.846153846153847,
    "23": 12.384615384615385,
    "24": 12.923076923076923,
    "25": 13.461538461538462,
    "26": 14
  },
  G: {
    "6": 4.061538461538462,
    "7": 4.738461538461539,
    "8": 5.415384615384616,
    "9": 6.092307692307693,
    "10": 6.769230769230769,
    "11": 7.446153846153847,
    "12": 8.123076923076924,
    "13": 8.8,
    "14": 9.476923076923079,
    "15": 10.153846153846153,
    "16": 10.830769230769231,
    "17": 11.50769230769231,
    "18": 12.184615384615386,
    "19": 12.861538461538462,
    "20": 13.538461538461538,
    "21": 14.215384615384616,
    "22": 14.892307692307694,
    "23": 15.569230769230769,
    "24": 16.24615384615385,
    "25": 16.923076923076927,
    "26": 17.6
  },
  H: {
    "6": 4.246153846153846,
    "7": 4.953846153846153,
    "8": 5.661538461538461,
    "9": 6.369230769230769,
    "10": 7.076923076923077,
    "11": 7.784615384615384,
    "12": 8.492307692307692,
    "13": 9.2,
    "14": 9.907692307692306,
    "15": 10.615384615384615,
    "16": 11.323076923076922,
    "17": 12.030769230769229,
    "18": 12.738461538461538,
    "19": 13.446153846153845,
    "20": 14.153846153846153,
    "21": 14.86153846153846,
    "22": 15.569230769230767,
    "23": 16.276923076923076,
    "24": 16.984615384615385,
    "25": 17.69230769230769,
    "26": 18.4
  },
  I: {
    "6": 1.6153846153846154,
    "7": 1.8846153846153846,
    "8": 2.1538461538461537,
    "9": 2.423076923076923,
    "10": 2.6923076923076925,
    "11": 2.9615384615384617,
    "12": 3.230769230769231,
    "13": 3.5,
    "14": 3.769230769230769,
    "15": 4.038461538461538,
    "16": 4.3076923076923075,
    "17": 4.576923076923077,
    "18": 4.846153846153846,
    "19": 5.115384615384615,
    "20": 5.384615384615385,
    "21": 5.653846153846154,
    "22": 5.923076923076923,
    "23": 6.1923076923076925,
    "24": 6.461538461538462,
    "25": 6.730769230769231,
    "26": 7
  },
  J: {
    "6": 3,
    "7": 3.5,
    "8": 4,
    "9": 4.5,
    "10": 5,
    "11": 5.5,
    "12": 6,
    "13": 6.5,
    "14": 7,
    "15": 7.5,
    "16": 8,
    "17": 8.5,
    "18": 9,
    "19": 9.5,
    "20": 10,
    "21": 10.5,
    "22": 11,
    "23": 11.5,
    "24": 12,
    "25": 12.5,
    "26": 13
  },
  K: {
    "6": 3.7846153846153845,
    "7": 4.415384615384615,
    "8": 5.046153846153846,
    "9": 5.676923076923076,
    "10": 6.3076923076923075,
    "11": 6.938461538461538,
    "12": 7.569230769230769,
    "13": 8.2,
    "14": 8.83076923076923,
    "15": 9.46153846153846,
    "16": 10.092307692307692,
    "17": 10.72307692307692,
    "18": 11.353846153846153,
    "19": 11.984615384615383,
    "20": 12.615384615384615,
    "21": 13.246153846153845,
    "22": 13.876923076923076,
    "23": 14.507692307692308,
    "24": 15.138461538461538,
    "25": 15.769230769230766,
    "26": 16.4
  },
  L: {
    "6": 3.1384615384615384,
    "7": 3.661538461538462,
    "8": 4.184615384615385,
    "9": 4.707692307692307,
    "10": 5.230769230769231,
    "11": 5.753846153846154,
    "12": 6.276923076923077,
    "13": 6.799999999999999,
    "14": 7.323076923076924,
    "15": 7.846153846153846,
    "16": 8.36923076923077,
    "17": 8.892307692307693,
    "18": 9.415384615384614,
    "19": 9.938461538461537,
    "20": 10.461538461538462,
    "21": 10.984615384615383,
    "22": 11.507692307692308,
    "23": 12.03076923076923,
    "24": 12.553846153846154,
    "25": 13.076923076923077,
    "26": 13.599999999999998
  },
  M: {
    "6": 5.261538461538462,
    "7": 6.138461538461538,
    "8": 7.015384615384615,
    "9": 7.892307692307693,
    "10": 8.76923076923077,
    "11": 9.646153846153847,
    "12": 10.523076923076925,
    "13": 11.400000000000002,
    "14": 12.276923076923076,
    "15": 13.153846153846153,
    "16": 14.03076923076923,
    "17": 14.907692307692308,
    "18": 15.784615384615385,
    "19": 16.661538461538463,
    "20": 17.53846153846154,
    "21": 18.415384615384617,
    "22": 19.292307692307695,
    "23": 20.16923076923077,
    "24": 21.04615384615385,
    "25": 21.923076923076923,
    "26": 22.800000000000004
  },
  N: {
    "6": 4.384615384615385,
    "7": 5.115384615384615,
    "8": 5.846153846153846,
    "9": 6.576923076923077,
    "10": 7.3076923076923075,
    "11": 8.038461538461538,
    "12": 8.76923076923077,
    "13": 9.5,
    "14": 10.23076923076923,
    "15": 10.961538461538462,
    "16": 11.692307692307692,
    "17": 12.423076923076923,
    "18": 13.153846153846153,
    "19": 13.884615384615385,
    "20": 14.615384615384615,
    "21": 15.346153846153847,
    "22": 16.076923076923077,
    "23": 16.807692307692307,
    "24": 17.53846153846154,
    "25": 18.26923076923077,
    "26": 19
  },
  O: {
    "6": 4.707692307692307,
    "7": 5.4923076923076914,
    "8": 6.276923076923077,
    "9": 7.061538461538461,
    "10": 7.846153846153846,
    "11": 8.63076923076923,
    "12": 9.415384615384614,
    "13": 10.2,
    "14": 10.984615384615383,
    "15": 11.76923076923077,
    "16": 12.553846153846154,
    "17": 13.338461538461537,
    "18": 14.123076923076923,
    "19": 14.907692307692306,
    "20": 15.692307692307692,
    "21": 16.476923076923075,
    "22": 17.26153846153846,
    "23": 18.046153846153846,
    "24": 18.830769230769228,
    "25": 19.615384615384613,
    "26": 20.4
  },
  P: {
    "6": 3.6923076923076925,
    "7": 4.3076923076923075,
    "8": 4.923076923076923,
    "9": 5.538461538461538,
    "10": 6.153846153846154,
    "11": 6.769230769230769,
    "12": 7.384615384615385,
    "13": 8,
    "14": 8.615384615384615,
    "15": 9.23076923076923,
    "16": 9.846153846153847,
    "17": 10.461538461538462,
    "18": 11.076923076923077,
    "19": 11.692307692307692,
    "20": 12.307692307692308,
    "21": 12.923076923076923,
    "22": 13.538461538461538,
    "23": 14.153846153846153,
    "24": 14.76923076923077,
    "25": 15.384615384615385,
    "26": 16
  },
  Q: {
    "6": 4.707692307692307,
    "7": 5.4923076923076914,
    "8": 6.276923076923077,
    "9": 7.061538461538461,
    "10": 7.846153846153846,
    "11": 8.63076923076923,
    "12": 9.415384615384614,
    "13": 10.2,
    "14": 10.984615384615383,
    "15": 11.76923076923077,
    "16": 12.553846153846154,
    "17": 13.338461538461537,
    "18": 14.123076923076923,
    "19": 14.907692307692306,
    "20": 15.692307692307692,
    "21": 16.476923076923075,
    "22": 17.26153846153846,
    "23": 18.046153846153846,
    "24": 18.830769230769228,
    "25": 19.615384615384613,
    "26": 20.4
  },
  R: {
    "6": 3.7846153846153845,
    "7": 4.415384615384615,
    "8": 5.046153846153846,
    "9": 5.676923076923076,
    "10": 6.3076923076923075,
    "11": 6.938461538461538,
    "12": 7.569230769230769,
    "13": 8.2,
    "14": 8.83076923076923,
    "15": 9.46153846153846,
    "16": 10.092307692307692,
    "17": 10.72307692307692,
    "18": 11.353846153846153,
    "19": 11.984615384615383,
    "20": 12.615384615384615,
    "21": 13.246153846153845,
    "22": 13.876923076923076,
    "23": 14.507692307692308,
    "24": 15.138461538461538,
    "25": 15.769230769230766,
    "26": 16.4
  },
  S: {
    "6": 3.230769230769231,
    "7": 3.769230769230769,
    "8": 4.3076923076923075,
    "9": 4.846153846153846,
    "10": 5.384615384615385,
    "11": 5.923076923076923,
    "12": 6.461538461538462,
    "13": 7,
    "14": 7.538461538461538,
    "15": 8.076923076923077,
    "16": 8.615384615384615,
    "17": 9.153846153846153,
    "18": 9.692307692307692,
    "19": 10.23076923076923,
    "20": 10.76923076923077,
    "21": 11.307692307692308,
    "22": 11.846153846153847,
    "23": 12.384615384615385,
    "24": 12.923076923076923,
    "25": 13.461538461538462,
    "26": 14
  },
  T: {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  U: {
    "6": 4.153846153846154,
    "7": 4.846153846153846,
    "8": 5.538461538461538,
    "9": 6.230769230769231,
    "10": 6.923076923076923,
    "11": 7.615384615384615,
    "12": 8.307692307692308,
    "13": 9,
    "14": 9.692307692307692,
    "15": 10.384615384615385,
    "16": 11.076923076923077,
    "17": 11.76923076923077,
    "18": 12.461538461538462,
    "19": 13.153846153846153,
    "20": 13.846153846153847,
    "21": 14.538461538461538,
    "22": 15.23076923076923,
    "23": 15.923076923076923,
    "24": 16.615384615384617,
    "25": 17.307692307692307,
    "26": 18
  },
  V: {
    "6": 3.969230769230769,
    "7": 4.63076923076923,
    "8": 5.292307692307692,
    "9": 5.953846153846153,
    "10": 6.615384615384615,
    "11": 7.276923076923077,
    "12": 7.938461538461538,
    "13": 8.6,
    "14": 9.26153846153846,
    "15": 9.923076923076923,
    "16": 10.584615384615384,
    "17": 11.246153846153845,
    "18": 11.907692307692306,
    "19": 12.569230769230769,
    "20": 13.23076923076923,
    "21": 13.892307692307693,
    "22": 14.553846153846154,
    "23": 15.215384615384615,
    "24": 15.876923076923076,
    "25": 16.53846153846154,
    "26": 17.2
  },
  W: {
    "6": 5.584615384615384,
    "7": 6.515384615384615,
    "8": 7.446153846153846,
    "9": 8.376923076923076,
    "10": 9.307692307692308,
    "11": 10.238461538461538,
    "12": 11.169230769230769,
    "13": 12.099999999999998,
    "14": 13.03076923076923,
    "15": 13.961538461538462,
    "16": 14.892307692307693,
    "17": 15.823076923076922,
    "18": 16.75384615384615,
    "19": 17.684615384615384,
    "20": 18.615384615384617,
    "21": 19.546153846153846,
    "22": 20.476923076923075,
    "23": 21.407692307692308,
    "24": 22.338461538461537,
    "25": 23.26923076923077,
    "26": 24.199999999999996
  },
  X: {
    "6": 3.830769230769231,
    "7": 4.46923076923077,
    "8": 5.107692307692308,
    "9": 5.746153846153846,
    "10": 6.384615384615385,
    "11": 7.023076923076924,
    "12": 7.661538461538462,
    "13": 8.3,
    "14": 8.93846153846154,
    "15": 9.576923076923078,
    "16": 10.215384615384616,
    "17": 10.853846153846156,
    "18": 11.492307692307692,
    "19": 12.130769230769232,
    "20": 12.76923076923077,
    "21": 13.407692307692308,
    "22": 14.046153846153848,
    "23": 14.684615384615386,
    "24": 15.323076923076924,
    "25": 15.961538461538463,
    "26": 16.6
  },
  Y: {
    "6": 3.5999999999999996,
    "7": 4.2,
    "8": 4.8,
    "9": 5.4,
    "10": 6,
    "11": 6.6,
    "12": 7.199999999999999,
    "13": 7.799999999999999,
    "14": 8.4,
    "15": 9,
    "16": 9.6,
    "17": 10.2,
    "18": 10.8,
    "19": 11.399999999999999,
    "20": 12,
    "21": 12.599999999999998,
    "22": 13.2,
    "23": 13.8,
    "24": 14.399999999999999,
    "25": 15,
    "26": 15.599999999999998
  },
  Z: {
    "6": 3.4615384615384617,
    "7": 4.038461538461538,
    "8": 4.615384615384615,
    "9": 5.1923076923076925,
    "10": 5.769230769230769,
    "11": 6.346153846153846,
    "12": 6.923076923076923,
    "13": 7.5,
    "14": 8.076923076923077,
    "15": 8.653846153846153,
    "16": 9.23076923076923,
    "17": 9.807692307692308,
    "18": 10.384615384615385,
    "19": 10.961538461538462,
    "20": 11.538461538461538,
    "21": 12.115384615384615,
    "22": 12.692307692307692,
    "23": 13.26923076923077,
    "24": 13.846153846153847,
    "25": 14.423076923076923,
    "26": 15
  },
  "[": {
    "6": 1.9846153846153844,
    "7": 2.315384615384615,
    "8": 2.646153846153846,
    "9": 2.9769230769230766,
    "10": 3.3076923076923075,
    "11": 3.6384615384615384,
    "12": 3.969230769230769,
    "13": 4.3,
    "14": 4.63076923076923,
    "15": 4.961538461538462,
    "16": 5.292307692307692,
    "17": 5.623076923076923,
    "18": 5.953846153846153,
    "19": 6.2846153846153845,
    "20": 6.615384615384615,
    "21": 6.946153846153846,
    "22": 7.276923076923077,
    "23": 7.607692307692307,
    "24": 7.938461538461538,
    "25": 8.26923076923077,
    "26": 8.6
  },
  "\\": {
    "6": 2.3076923076923075,
    "7": 2.6923076923076925,
    "8": 3.076923076923077,
    "9": 3.4615384615384617,
    "10": 3.8461538461538463,
    "11": 4.230769230769231,
    "12": 4.615384615384615,
    "13": 5,
    "14": 5.384615384615385,
    "15": 5.769230769230769,
    "16": 6.153846153846154,
    "17": 6.538461538461538,
    "18": 6.923076923076923,
    "19": 7.3076923076923075,
    "20": 7.6923076923076925,
    "21": 8.076923076923077,
    "22": 8.461538461538462,
    "23": 8.846153846153847,
    "24": 9.23076923076923,
    "25": 9.615384615384615,
    "26": 10
  },
  "]": {
    "6": 1.9846153846153844,
    "7": 2.315384615384615,
    "8": 2.646153846153846,
    "9": 2.9769230769230766,
    "10": 3.3076923076923075,
    "11": 3.6384615384615384,
    "12": 3.969230769230769,
    "13": 4.3,
    "14": 4.63076923076923,
    "15": 4.961538461538462,
    "16": 5.292307692307692,
    "17": 5.623076923076923,
    "18": 5.953846153846153,
    "19": 6.2846153846153845,
    "20": 6.615384615384615,
    "21": 6.946153846153846,
    "22": 7.276923076923077,
    "23": 7.607692307692307,
    "24": 7.938461538461538,
    "25": 8.26923076923077,
    "26": 8.6
  },
  "^": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  },
  _: {
    "6": 2.9538461538461545,
    "7": 3.4461538461538463,
    "8": 3.9384615384615387,
    "9": 4.430769230769231,
    "10": 4.923076923076923,
    "11": 5.415384615384616,
    "12": 5.907692307692309,
    "13": 6.4,
    "14": 6.892307692307693,
    "15": 7.384615384615385,
    "16": 7.876923076923077,
    "17": 8.36923076923077,
    "18": 8.861538461538462,
    "19": 9.353846153846154,
    "20": 9.846153846153847,
    "21": 10.338461538461539,
    "22": 10.830769230769231,
    "23": 11.323076923076924,
    "24": 11.815384615384618,
    "25": 12.307692307692308,
    "26": 12.8
  },
  "`": {
    "6": 2.2615384615384615,
    "7": 2.638461538461539,
    "8": 3.0153846153846158,
    "9": 3.3923076923076922,
    "10": 3.769230769230769,
    "11": 4.1461538461538465,
    "12": 4.523076923076923,
    "13": 4.9,
    "14": 5.276923076923078,
    "15": 5.653846153846154,
    "16": 6.0307692307692315,
    "17": 6.407692307692309,
    "18": 6.7846153846153845,
    "19": 7.161538461538462,
    "20": 7.538461538461538,
    "21": 7.915384615384616,
    "22": 8.292307692307693,
    "23": 8.669230769230769,
    "24": 9.046153846153846,
    "25": 9.423076923076923,
    "26": 9.8
  },
  a: {
    "6": 3.1384615384615384,
    "7": 3.661538461538462,
    "8": 4.184615384615385,
    "9": 4.707692307692307,
    "10": 5.230769230769231,
    "11": 5.753846153846154,
    "12": 6.276923076923077,
    "13": 6.799999999999999,
    "14": 7.323076923076924,
    "15": 7.846153846153846,
    "16": 8.36923076923077,
    "17": 8.892307692307693,
    "18": 9.415384615384614,
    "19": 9.938461538461537,
    "20": 10.461538461538462,
    "21": 10.984615384615383,
    "22": 11.507692307692308,
    "23": 12.03076923076923,
    "24": 12.553846153846154,
    "25": 13.076923076923077,
    "26": 13.599999999999998
  },
  b: {
    "6": 3.553846153846154,
    "7": 4.146153846153846,
    "8": 4.7384615384615385,
    "9": 5.3307692307692305,
    "10": 5.923076923076923,
    "11": 6.515384615384615,
    "12": 7.107692307692308,
    "13": 7.700000000000001,
    "14": 8.292307692307691,
    "15": 8.884615384615385,
    "16": 9.476923076923077,
    "17": 10.069230769230769,
    "18": 10.661538461538461,
    "19": 11.253846153846155,
    "20": 11.846153846153847,
    "21": 12.43846153846154,
    "22": 13.03076923076923,
    "23": 13.623076923076923,
    "24": 14.215384615384616,
    "25": 14.807692307692308,
    "26": 15.400000000000002
  },
  c: {
    "6": 2.815384615384615,
    "7": 3.2846153846153845,
    "8": 3.753846153846154,
    "9": 4.223076923076923,
    "10": 4.6923076923076925,
    "11": 5.161538461538461,
    "12": 5.63076923076923,
    "13": 6.1,
    "14": 6.569230769230769,
    "15": 7.038461538461538,
    "16": 7.507692307692308,
    "17": 7.976923076923076,
    "18": 8.446153846153846,
    "19": 8.915384615384614,
    "20": 9.384615384615385,
    "21": 9.853846153846153,
    "22": 10.323076923076922,
    "23": 10.792307692307691,
    "24": 11.26153846153846,
    "25": 11.73076923076923,
    "26": 12.2
  },
  d: {
    "6": 3.553846153846154,
    "7": 4.146153846153846,
    "8": 4.7384615384615385,
    "9": 5.3307692307692305,
    "10": 5.923076923076923,
    "11": 6.515384615384615,
    "12": 7.107692307692308,
    "13": 7.700000000000001,
    "14": 8.292307692307691,
    "15": 8.884615384615385,
    "16": 9.476923076923077,
    "17": 10.069230769230769,
    "18": 10.661538461538461,
    "19": 11.253846153846155,
    "20": 11.846153846153847,
    "21": 12.43846153846154,
    "22": 13.03076923076923,
    "23": 13.623076923076923,
    "24": 14.215384615384616,
    "25": 14.807692307692308,
    "26": 15.400000000000002
  },
  e: {
    "6": 3.369230769230769,
    "7": 3.930769230769231,
    "8": 4.492307692307692,
    "9": 5.053846153846154,
    "10": 5.615384615384615,
    "11": 6.176923076923076,
    "12": 6.738461538461538,
    "13": 7.299999999999999,
    "14": 7.861538461538462,
    "15": 8.423076923076923,
    "16": 8.984615384615385,
    "17": 9.546153846153846,
    "18": 10.107692307692307,
    "19": 10.669230769230769,
    "20": 11.23076923076923,
    "21": 11.792307692307691,
    "22": 12.353846153846153,
    "23": 12.915384615384616,
    "24": 13.476923076923075,
    "25": 14.038461538461538,
    "26": 14.599999999999998
  },
  f: {
    "6": 2.3538461538461535,
    "7": 2.7461538461538457,
    "8": 3.1384615384615384,
    "9": 3.5307692307692307,
    "10": 3.923076923076923,
    "11": 4.315384615384615,
    "12": 4.707692307692307,
    "13": 5.1,
    "14": 5.4923076923076914,
    "15": 5.884615384615385,
    "16": 6.276923076923077,
    "17": 6.669230769230769,
    "18": 7.061538461538461,
    "19": 7.453846153846153,
    "20": 7.846153846153846,
    "21": 8.238461538461538,
    "22": 8.63076923076923,
    "23": 9.023076923076923,
    "24": 9.415384615384614,
    "25": 9.807692307692307,
    "26": 10.2
  },
  g: {
    "6": 3.507692307692307,
    "7": 4.092307692307692,
    "8": 4.676923076923076,
    "9": 5.261538461538461,
    "10": 5.846153846153846,
    "11": 6.43076923076923,
    "12": 7.015384615384614,
    "13": 7.6,
    "14": 8.184615384615384,
    "15": 8.76923076923077,
    "16": 9.353846153846153,
    "17": 9.938461538461537,
    "18": 10.523076923076921,
    "19": 11.107692307692307,
    "20": 11.692307692307692,
    "21": 12.276923076923076,
    "22": 12.86153846153846,
    "23": 13.446153846153845,
    "24": 14.030769230769229,
    "25": 14.615384615384615,
    "26": 15.2
  },
  h: {
    "6": 3.4615384615384617,
    "7": 4.038461538461538,
    "8": 4.615384615384615,
    "9": 5.1923076923076925,
    "10": 5.769230769230769,
    "11": 6.346153846153846,
    "12": 6.923076923076923,
    "13": 7.5,
    "14": 8.076923076923077,
    "15": 8.653846153846153,
    "16": 9.23076923076923,
    "17": 9.807692307692308,
    "18": 10.384615384615385,
    "19": 10.961538461538462,
    "20": 11.538461538461538,
    "21": 12.115384615384615,
    "22": 12.692307692307692,
    "23": 13.26923076923077,
    "24": 13.846153846153847,
    "25": 14.423076923076923,
    "26": 15
  },
  i: {
    "6": 1.5230769230769228,
    "7": 1.7769230769230768,
    "8": 2.0307692307692307,
    "9": 2.2846153846153845,
    "10": 2.5384615384615383,
    "11": 2.792307692307692,
    "12": 3.0461538461538455,
    "13": 3.3,
    "14": 3.5538461538461537,
    "15": 3.8076923076923075,
    "16": 4.061538461538461,
    "17": 4.315384615384615,
    "18": 4.569230769230769,
    "19": 4.823076923076923,
    "20": 5.076923076923077,
    "21": 5.3307692307692305,
    "22": 5.584615384615384,
    "23": 5.838461538461538,
    "24": 6.092307692307691,
    "25": 6.346153846153846,
    "26": 6.6
  },
  j: {
    "6": 1.5230769230769228,
    "7": 1.7769230769230768,
    "8": 2.0307692307692307,
    "9": 2.2846153846153845,
    "10": 2.5384615384615383,
    "11": 2.792307692307692,
    "12": 3.0461538461538455,
    "13": 3.3,
    "14": 3.5538461538461537,
    "15": 3.8076923076923075,
    "16": 4.061538461538461,
    "17": 4.315384615384615,
    "18": 4.569230769230769,
    "19": 4.823076923076923,
    "20": 5.076923076923077,
    "21": 5.3307692307692305,
    "22": 5.584615384615384,
    "23": 5.838461538461538,
    "24": 6.092307692307691,
    "25": 6.346153846153846,
    "26": 6.6
  },
  k: {
    "6": 3.1384615384615384,
    "7": 3.661538461538462,
    "8": 4.184615384615385,
    "9": 4.707692307692307,
    "10": 5.230769230769231,
    "11": 5.753846153846154,
    "12": 6.276923076923077,
    "13": 6.799999999999999,
    "14": 7.323076923076924,
    "15": 7.846153846153846,
    "16": 8.36923076923077,
    "17": 8.892307692307693,
    "18": 9.415384615384614,
    "19": 9.938461538461537,
    "20": 10.461538461538462,
    "21": 10.984615384615383,
    "22": 11.507692307692308,
    "23": 12.03076923076923,
    "24": 12.553846153846154,
    "25": 13.076923076923077,
    "26": 13.599999999999998
  },
  l: {
    "6": 1.6615384615384616,
    "7": 1.9384615384615385,
    "8": 2.2153846153846155,
    "9": 2.4923076923076923,
    "10": 2.769230769230769,
    "11": 3.0461538461538464,
    "12": 3.3230769230769233,
    "13": 3.6000000000000005,
    "14": 3.876923076923077,
    "15": 4.153846153846154,
    "16": 4.430769230769231,
    "17": 4.707692307692308,
    "18": 4.984615384615385,
    "19": 5.261538461538462,
    "20": 5.538461538461538,
    "21": 5.815384615384616,
    "22": 6.092307692307693,
    "23": 6.369230769230769,
    "24": 6.6461538461538465,
    "25": 6.923076923076923,
    "26": 7.200000000000001
  },
  m: {
    "6": 5.169230769230769,
    "7": 6.03076923076923,
    "8": 6.892307692307692,
    "9": 7.753846153846154,
    "10": 8.615384615384615,
    "11": 9.476923076923075,
    "12": 10.338461538461537,
    "13": 11.2,
    "14": 12.06153846153846,
    "15": 12.923076923076923,
    "16": 13.784615384615384,
    "17": 14.646153846153844,
    "18": 15.507692307692308,
    "19": 16.369230769230768,
    "20": 17.23076923076923,
    "21": 18.092307692307692,
    "22": 18.95384615384615,
    "23": 19.815384615384612,
    "24": 20.676923076923075,
    "25": 21.53846153846154,
    "26": 22.4
  },
  n: {
    "6": 3.4615384615384617,
    "7": 4.038461538461538,
    "8": 4.615384615384615,
    "9": 5.1923076923076925,
    "10": 5.769230769230769,
    "11": 6.346153846153846,
    "12": 6.923076923076923,
    "13": 7.5,
    "14": 8.076923076923077,
    "15": 8.653846153846153,
    "16": 9.23076923076923,
    "17": 9.807692307692308,
    "18": 10.384615384615385,
    "19": 10.961538461538462,
    "20": 11.538461538461538,
    "21": 12.115384615384615,
    "22": 12.692307692307692,
    "23": 13.26923076923077,
    "24": 13.846153846153847,
    "25": 14.423076923076923,
    "26": 15
  },
  o: {
    "6": 3.553846153846154,
    "7": 4.146153846153846,
    "8": 4.7384615384615385,
    "9": 5.3307692307692305,
    "10": 5.923076923076923,
    "11": 6.515384615384615,
    "12": 7.107692307692308,
    "13": 7.700000000000001,
    "14": 8.292307692307691,
    "15": 8.884615384615385,
    "16": 9.476923076923077,
    "17": 10.069230769230769,
    "18": 10.661538461538461,
    "19": 11.253846153846155,
    "20": 11.846153846153847,
    "21": 12.43846153846154,
    "22": 13.03076923076923,
    "23": 13.623076923076923,
    "24": 14.215384615384616,
    "25": 14.807692307692308,
    "26": 15.400000000000002
  },
  p: {
    "6": 3.553846153846154,
    "7": 4.146153846153846,
    "8": 4.7384615384615385,
    "9": 5.3307692307692305,
    "10": 5.923076923076923,
    "11": 6.515384615384615,
    "12": 7.107692307692308,
    "13": 7.700000000000001,
    "14": 8.292307692307691,
    "15": 8.884615384615385,
    "16": 9.476923076923077,
    "17": 10.069230769230769,
    "18": 10.661538461538461,
    "19": 11.253846153846155,
    "20": 11.846153846153847,
    "21": 12.43846153846154,
    "22": 13.03076923076923,
    "23": 13.623076923076923,
    "24": 14.215384615384616,
    "25": 14.807692307692308,
    "26": 15.400000000000002
  },
  q: {
    "6": 3.553846153846154,
    "7": 4.146153846153846,
    "8": 4.7384615384615385,
    "9": 5.3307692307692305,
    "10": 5.923076923076923,
    "11": 6.515384615384615,
    "12": 7.107692307692308,
    "13": 7.700000000000001,
    "14": 8.292307692307691,
    "15": 8.884615384615385,
    "16": 9.476923076923077,
    "17": 10.069230769230769,
    "18": 10.661538461538461,
    "19": 11.253846153846155,
    "20": 11.846153846153847,
    "21": 12.43846153846154,
    "22": 13.03076923076923,
    "23": 13.623076923076923,
    "24": 14.215384615384616,
    "25": 14.807692307692308,
    "26": 15.400000000000002
  },
  r: {
    "6": 2.3538461538461535,
    "7": 2.7461538461538457,
    "8": 3.1384615384615384,
    "9": 3.5307692307692307,
    "10": 3.923076923076923,
    "11": 4.315384615384615,
    "12": 4.707692307692307,
    "13": 5.1,
    "14": 5.4923076923076914,
    "15": 5.884615384615385,
    "16": 6.276923076923077,
    "17": 6.669230769230769,
    "18": 7.061538461538461,
    "19": 7.453846153846153,
    "20": 7.846153846153846,
    "21": 8.238461538461538,
    "22": 8.63076923076923,
    "23": 9.023076923076923,
    "24": 9.415384615384614,
    "25": 9.807692307692307,
    "26": 10.2
  },
  s: {
    "6": 2.6769230769230767,
    "7": 3.123076923076923,
    "8": 3.569230769230769,
    "9": 4.015384615384615,
    "10": 4.461538461538462,
    "11": 4.907692307692307,
    "12": 5.3538461538461535,
    "13": 5.799999999999999,
    "14": 6.246153846153846,
    "15": 6.6923076923076925,
    "16": 7.138461538461538,
    "17": 7.584615384615384,
    "18": 8.03076923076923,
    "19": 8.476923076923077,
    "20": 8.923076923076923,
    "21": 9.36923076923077,
    "22": 9.815384615384614,
    "23": 10.261538461538462,
    "24": 10.707692307692307,
    "25": 11.153846153846153,
    "26": 11.599999999999998
  },
  t: {
    "6": 2.446153846153846,
    "7": 2.853846153846154,
    "8": 3.2615384615384615,
    "9": 3.669230769230769,
    "10": 4.076923076923077,
    "11": 4.484615384615385,
    "12": 4.892307692307692,
    "13": 5.299999999999999,
    "14": 5.707692307692308,
    "15": 6.115384615384615,
    "16": 6.523076923076923,
    "17": 6.93076923076923,
    "18": 7.338461538461538,
    "19": 7.746153846153846,
    "20": 8.153846153846153,
    "21": 8.561538461538461,
    "22": 8.96923076923077,
    "23": 9.376923076923076,
    "24": 9.784615384615384,
    "25": 10.192307692307692,
    "26": 10.599999999999998
  },
  u: {
    "6": 3.4615384615384617,
    "7": 4.038461538461538,
    "8": 4.615384615384615,
    "9": 5.1923076923076925,
    "10": 5.769230769230769,
    "11": 6.346153846153846,
    "12": 6.923076923076923,
    "13": 7.5,
    "14": 8.076923076923077,
    "15": 8.653846153846153,
    "16": 9.23076923076923,
    "17": 9.807692307692308,
    "18": 10.384615384615385,
    "19": 10.961538461538462,
    "20": 11.538461538461538,
    "21": 12.115384615384615,
    "22": 12.692307692307692,
    "23": 13.26923076923077,
    "24": 13.846153846153847,
    "25": 14.423076923076923,
    "26": 15
  },
  v: {
    "6": 3.0461538461538455,
    "7": 3.5538461538461537,
    "8": 4.061538461538461,
    "9": 4.569230769230769,
    "10": 5.076923076923077,
    "11": 5.584615384615384,
    "12": 6.092307692307691,
    "13": 6.6,
    "14": 7.107692307692307,
    "15": 7.615384615384615,
    "16": 8.123076923076923,
    "17": 8.63076923076923,
    "18": 9.138461538461538,
    "19": 9.646153846153846,
    "20": 10.153846153846153,
    "21": 10.661538461538461,
    "22": 11.169230769230769,
    "23": 11.676923076923076,
    "24": 12.184615384615382,
    "25": 12.692307692307692,
    "26": 13.2
  },
  w: {
    "6": 4.707692307692307,
    "7": 5.4923076923076914,
    "8": 6.276923076923077,
    "9": 7.061538461538461,
    "10": 7.846153846153846,
    "11": 8.63076923076923,
    "12": 9.415384615384614,
    "13": 10.2,
    "14": 10.984615384615383,
    "15": 11.76923076923077,
    "16": 12.553846153846154,
    "17": 13.338461538461537,
    "18": 14.123076923076923,
    "19": 14.907692307692306,
    "20": 15.692307692307692,
    "21": 16.476923076923075,
    "22": 17.26153846153846,
    "23": 18.046153846153846,
    "24": 18.830769230769228,
    "25": 19.615384615384613,
    "26": 20.4
  },
  x: {
    "6": 3.0923076923076924,
    "7": 3.6076923076923078,
    "8": 4.1230769230769235,
    "9": 4.638461538461539,
    "10": 5.153846153846154,
    "11": 5.6692307692307695,
    "12": 6.184615384615385,
    "13": 6.700000000000001,
    "14": 7.2153846153846155,
    "15": 7.730769230769231,
    "16": 8.246153846153847,
    "17": 8.761538461538462,
    "18": 9.276923076923078,
    "19": 9.792307692307691,
    "20": 10.307692307692308,
    "21": 10.823076923076924,
    "22": 11.338461538461539,
    "23": 11.853846153846153,
    "24": 12.36923076923077,
    "25": 12.884615384615385,
    "26": 13.400000000000002
  },
  y: {
    "6": 3,
    "7": 3.5,
    "8": 4,
    "9": 4.5,
    "10": 5,
    "11": 5.5,
    "12": 6,
    "13": 6.5,
    "14": 7,
    "15": 7.5,
    "16": 8,
    "17": 8.5,
    "18": 9,
    "19": 9.5,
    "20": 10,
    "21": 10.5,
    "22": 11,
    "23": 11.5,
    "24": 12,
    "25": 12.5,
    "26": 13
  },
  z: {
    "6": 2.8615384615384616,
    "7": 3.338461538461538,
    "8": 3.8153846153846156,
    "9": 4.292307692307693,
    "10": 4.769230769230769,
    "11": 5.246153846153846,
    "12": 5.723076923076923,
    "13": 6.200000000000001,
    "14": 6.676923076923076,
    "15": 7.153846153846154,
    "16": 7.630769230769231,
    "17": 8.107692307692307,
    "18": 8.584615384615386,
    "19": 9.061538461538461,
    "20": 9.538461538461538,
    "21": 10.015384615384617,
    "22": 10.492307692307692,
    "23": 10.96923076923077,
    "24": 11.446153846153846,
    "25": 11.923076923076923,
    "26": 12.400000000000002
  },
  "{": {
    "6": 2.030769230769231,
    "7": 2.3692307692307697,
    "8": 2.707692307692308,
    "9": 3.0461538461538464,
    "10": 3.3846153846153846,
    "11": 3.7230769230769236,
    "12": 4.061538461538462,
    "13": 4.4,
    "14": 4.738461538461539,
    "15": 5.076923076923077,
    "16": 5.415384615384616,
    "17": 5.753846153846155,
    "18": 6.092307692307693,
    "19": 6.430769230769231,
    "20": 6.769230769230769,
    "21": 7.107692307692308,
    "22": 7.446153846153847,
    "23": 7.7846153846153845,
    "24": 8.123076923076924,
    "25": 8.461538461538463,
    "26": 8.8
  },
  "|": {
    "6": 1.7076923076923078,
    "7": 1.9923076923076926,
    "8": 2.276923076923077,
    "9": 2.5615384615384618,
    "10": 2.8461538461538463,
    "11": 3.130769230769231,
    "12": 3.4153846153846157,
    "13": 3.7,
    "14": 3.984615384615385,
    "15": 4.269230769230769,
    "16": 4.553846153846154,
    "17": 4.838461538461539,
    "18": 5.1230769230769235,
    "19": 5.407692307692307,
    "20": 5.6923076923076925,
    "21": 5.976923076923077,
    "22": 6.261538461538462,
    "23": 6.546153846153847,
    "24": 6.830769230769231,
    "25": 7.115384615384615,
    "26": 7.4
  },
  "}": {
    "6": 2.030769230769231,
    "7": 2.3692307692307697,
    "8": 2.707692307692308,
    "9": 3.0461538461538464,
    "10": 3.3846153846153846,
    "11": 3.7230769230769236,
    "12": 4.061538461538462,
    "13": 4.4,
    "14": 4.738461538461539,
    "15": 5.076923076923077,
    "16": 5.415384615384616,
    "17": 5.753846153846155,
    "18": 6.092307692307693,
    "19": 6.430769230769231,
    "20": 6.769230769230769,
    "21": 7.107692307692308,
    "22": 7.446153846153847,
    "23": 7.7846153846153845,
    "24": 8.123076923076924,
    "25": 8.461538461538463,
    "26": 8.8
  },
  "~": {
    "6": 3.4153846153846157,
    "7": 3.984615384615385,
    "8": 4.553846153846154,
    "9": 5.1230769230769235,
    "10": 5.6923076923076925,
    "11": 6.261538461538462,
    "12": 6.830769230769231,
    "13": 7.4,
    "14": 7.96923076923077,
    "15": 8.538461538461538,
    "16": 9.107692307692307,
    "17": 9.676923076923078,
    "18": 10.246153846153847,
    "19": 10.815384615384614,
    "20": 11.384615384615385,
    "21": 11.953846153846154,
    "22": 12.523076923076925,
    "23": 13.092307692307694,
    "24": 13.661538461538463,
    "25": 14.23076923076923,
    "26": 14.8
  }
};
